import { ItemImageUploadState } from 'src/react/itemImageUpload/state/ItemImageUploadState';

export const ITEM_IMAGE_UPLOAD_DEFAULT_STATE: ItemImageUploadState = {
    loading: false,
    error: null,
    image: null,
};
